import { FC, ReactNode } from 'react';
import useDesktopMediaQuery from '../hooks/use-desktop-media-query';

interface MobileOrTabletMediaQueryProps {
    children: ReactNode;
}

const MobileOrTabletMediaQuery: FC<MobileOrTabletMediaQueryProps> = (props) => {
    const { children } = props;

    const isDesktop = useDesktopMediaQuery();

    return !isDesktop ? <>{children}</> : null;
};

export default MobileOrTabletMediaQuery;
